import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * useVerifiedBadges - takes an array of student IDs, returns a map
 * { student_id: { is_verified, plan_code, best_score, badge_expires_at } }.
 * Debounced + deduped + cached across components within the same session.
 */
const _cache = new Map();  // sid -> badge object (or null if checked, not verified)
let _inflight = null;

export default function useVerifiedBadges(studentIds) {
  const [badges, setBadges] = useState({});

  useEffect(() => {
    const ids = (studentIds || []).filter(Boolean);
    if (ids.length === 0) { setBadges({}); return; }

    const missing = ids.filter(id => !_cache.has(id));
    if (missing.length === 0) {
      const result = {};
      ids.forEach(id => {
        const c = _cache.get(id);
        if (c && c.is_verified) result[id] = c;
      });
      setBadges(result);
      return;
    }

    let cancelled = false;
    const load = async () => {
      try {
        const res = await axios.post(`${API}/api/verified-talent/badges/bulk`, { student_ids: missing });
        const got = res.data?.badges || {};
        missing.forEach(id => _cache.set(id, got[id] || null));
        if (cancelled) return;
        const result = {};
        ids.forEach(id => {
          const c = _cache.get(id);
          if (c && c.is_verified) result[id] = c;
        });
        setBadges(result);
      } catch {
        // fail silently - badge is enhancement, not core UX
      }
    };
    load();
    return () => { cancelled = true; };
  }, [JSON.stringify((studentIds || []).sort())]); // eslint-disable-line

  return badges;
}
